import { useCallback } from "react";
import { ConnectProto } from "@racoon/api";
import { Namespace, useT } from "@racoon/i18n";
import { useModal } from "@racoon/ui";
import { WhatsappDialogueContent } from "../components/whatsapp-dialogue.content";

export function useWhatsappDialogueModal() {
  const { openModal } = useModal();
  const t = useT();

  const openWhatsappDialogue = useCallback(
    (job: ConnectProto.Job) => {
      openModal({
        size: "custom",
        // The chat card is the modal: a phone-width frame with its own header
        width: { md: 385 },
        height: { md: "min(804px, 90svh)" },
        align: "right",
        className: "!gap-0 overflow-hidden",
        showClose: false,
        srTitle: t(Namespace.Orders, "whatsappDialogue.title"),
        bodyClassName: "flex min-h-0 flex-1 flex-col !p-0",
        body: <WhatsappDialogueContent job={job} />,
      });
    },
    [openModal, t],
  );

  return { openWhatsappDialogue };
}
